import { create } from "zustand";

const useLoaderStore = create((set) => ({
  showLoader: false,
  setShowLoader: (showLoader) => set(() => ({ showLoader })),
}));

export default useLoaderStore;
